export default __webpack_public_path__ + "static/media/pos2.049bf67d.png";